const BREAKPOINTS = {
  md: 768,
  tabletWidth: 600,
};

export default BREAKPOINTS;
